// DEPRECATED
// Activity cards are being rewritten to be page-specific cards for v2.5 card redesign
define('home/views/common/ActivityFooterView',[
    'backbone-marionette',
    'home/models/Session',
], function (
    Marionette,
    Session
) {
    'use strict';

    /**
     * Parent class, not intended to be instatiated.
     */
    var ActivityFooterView = Marionette.ItemView.extend({
        templateHelpers: function () {
            var session = Session.get();

            return {
                favorited: this.model.thread.get('userScore') > 0,
                discussionRoute: this.model.thread.getDiscussionRoute(),
                authenticated: !session.isAnonymous(),
            };
        },

        events: {
            'click [data-action=favorite]': 'toggleThreadFavorited',
        },

        initialize: function () {
            this.listenTo(this.model.thread, 'change:userScore', this.render);
        },

        toggleThreadFavorited: function (evt) {
            if (evt)
                evt.preventDefault();

            this.model.thread.toggleFavorited();
        },
    });

    return ActivityFooterView;
});

